module.exports = __webpack_public_path__ + "static/media/My_Vital_View_Mobile_App_Download_and_Use_Guide.748d0918.pdf";